<template>
  <div id="app">    

    <search-bar/>
    <!-- ##### Preloader ##### -->
    <div id="preloader">
        <div class="circle">
            <img src="img/core-img/church.png" alt="">
        </div>
    </div>

    <livestream/>
    <nav-bar />
    <router-view />
    <footer-vue/>


    <external-scripts/>
  </div>
</template>

<script>
import NavBar from "./components/NavBar";
import SearchBar from "./components/SearchBar";
import ExternalScripts from "./components/ExternalScripts";
import FooterVue from "./components/Footer.vue";
import Livestream from './components/Livestream.vue';

export default {  
  components: { NavBar, SearchBar, ExternalScripts, FooterVue, Livestream },
  watch: {
    $route(to, from) {
      setTimeout(() => {
        this.loadScript = false;
      }, 300);
      this.loadScript = true;
    },
  },
  data() {
    return {
      loadScript: true,
    };
  },
  methods: {
    toggleNavbar() {
      this.$refs.navbar.toggle();
    },
  },
};
</script>

<style>
.brown {
  color: #ac8a74;
}
</style>


